import { useEffect, useState } from "react";
import { Slider } from "../ui/slider";
import { usePricing } from "./usePricing";

export const Calculator = () => {
  const { mode, commission_rates: TIERS } = usePricing();
  const free = mode === "free";
  const [heads, setHeads] = useState(50);
  const [rate, setRate] = useState(TIERS[0]);
  useEffect(() => { setRate(TIERS[0]); }, [TIERS]);
  const total = free ? 0 : heads * rate;

  return (
    <section id="calculator" className="scroll-mt-20 border-t border-white/5 bg-[#0B1120] py-20 lg:py-28">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-12 lg:items-center lg:px-8">
        <div className="lg:col-span-5">
          <p className="eyebrow">Commission ledger</p>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-white lg:text-3xl">Pay per active head. Nothing hidden.</h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Commission is a fixed per-head monthly fee on OTP-verified active placements. Invoices are generated monthly from your active headcount — or on an agreed percentage bill split.
          </p>
        </div>
        <div data-testid="calculator-container" className="rounded-2xl border border-white/10 bg-[#0F172A] p-5 sm:p-6 lg:col-span-7">
          <div className="flex items-baseline justify-between">
            <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">Active headcount</span>
            <span data-testid="calculator-headcount-value" className="font-heading text-2xl font-extrabold text-white">{heads}</span>
          </div>
          <Slider data-testid="calculator-headcount-slider" min={10} max={1000} step={10} value={[heads]} onValueChange={(v) => setHeads(v[0])} className="mt-4" />
          <div className="mt-2 flex justify-between font-mono text-xs text-slate-500"><span>10</span><span>1000</span></div>
          <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">Rate per head / month</p>
          <div data-testid="calculator-tier-select" className="mt-3 grid gap-2" style={{ gridTemplateColumns: `repeat(${Math.min(TIERS.length, 5)}, minmax(0, 1fr))` }}>
            {TIERS.map((t) => (
              <button key={t} onClick={() => setRate(t)} disabled={free} data-testid={`calculator-tier-${t}`}
                className={`rounded-lg border py-2 font-mono text-sm font-semibold transition-colors ${rate === t ? "border-orange-500 bg-orange-500 text-white" : "border-slate-300 bg-white text-slate-300 hover:border-orange-400"}`}>
                ₹{t.toLocaleString("en-IN")}
              </button>
            ))}
          </div>
          <div className="mt-5 flex flex-col justify-between gap-2 border-t border-white/10 pt-4 sm:flex-row sm:items-end">
            <span className="text-sm text-slate-400">Estimated monthly commission</span>
            <span data-testid="calculator-monthly-result" className="font-heading text-3xl font-extrabold text-orange-500">₹{total.toLocaleString("en-IN")}</span>
          </div>
          <p className="mt-3 text-xs text-slate-500">Estimate only, excluding GST. {free ? "Commission is currently waived — free period." : "Final rate depends on cadre, location and contract."}</p>
        </div>
      </div>
    </section>
  );
};
